import type { Properties } from 'js-java-properties'
import { setProperty } from 'js-java-properties'

import type { TillquistConfig } from '@/features/controller/configuration/models/raspiProperties/types'
import { getBooleanProperty } from '@/features/controller/configuration/models/raspiProperties/utils'

const PROP_TILLQUIST_POWER_ENABLED = 'tillquistMeter.power.enabled'
const PROP_TILLQUIST_FREQUENCY_ENABLED = 'tillquistMeter.frequency.enabled'

export function isTillquistEnabled(tillquistConfig: TillquistConfig) {
  return tillquistConfig.powerEnabled || tillquistConfig.frequencyEnabled
}

export function readTillquistConfig(properties: Properties): TillquistConfig {
  return {
    powerEnabled: getBooleanProperty(properties, PROP_TILLQUIST_POWER_ENABLED),
    frequencyEnabled: getBooleanProperty(properties, PROP_TILLQUIST_FREQUENCY_ENABLED),
  }
}

export function writeTillquistConfig(properties: Properties, config: TillquistConfig) {
  setProperty(properties, PROP_TILLQUIST_POWER_ENABLED, config.powerEnabled ? 'true' : null)
  setProperty(properties, PROP_TILLQUIST_FREQUENCY_ENABLED, config.frequencyEnabled ? 'true' : null)
}
